/**
 * Heurística de rótulo para cards/lista de agentes (crew), até existir tipo na API.
 */
export function inferAgentCategory(crew) {
    const t = `${crew?.name || ''} ${crew?.description || ''}`.toLowerCase();
    if (/ativ|corre|prova|exerc|tarefa|homework/.test(t)) {
        return { label: 'Atividades', tone: 'blue' };
    }
    if (/avis|comunic|circul|mensagem|email|pais|famíl|notifica/.test(t)) {
        return { label: 'Avisos', tone: 'amber' };
    }
    if (/plan|aula|conteúdo|didát|pedag/.test(t)) {
        return { label: 'Planejamento', tone: 'mint' };
    }
    if (/dúvid|duvid|chat|faq|suporte|ajuda/.test(t)) {
        return { label: 'Suporte', tone: 'cyan' };
    }
    return { label: 'Geral', tone: 'slate' };
}

export function excerpt(text, max = 140) {
    if (!text || !String(text).trim()) {
        return 'Sem descrição cadastrada.';
    }
    const s = String(text).trim();
    if (s.length <= max) return s;
    return `${s.slice(0, max - 1)}…`;
}
